import Navbar from '../../components/navbar/navbar';
import Collection from '../Collection';
import Welcome from '../Welcome';
import Tasks from '../Tasks';
import Credits from '../Credits';
import SaveLoad from '../SaveLoad'
import "../../styles.css"
import { useState } from 'react';
import OpenBoosters from '../OpenBoosters';

export default function Homepage() {
  const [activeComponent, setActiveComponent] = useState('welcome');

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'welcome':
        return <Welcome />;
      case 'collection':
        return <Collection />;
      case 'tasks':
        return <Tasks />;
      case 'openBoosters':
        return <OpenBoosters />;
      case 'saveLoad':
        return <SaveLoad />;
      case 'credits':
        return <Credits />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className='contentWrapper'>
        <Navbar setActiveComponent={setActiveComponent} />
        {renderActiveComponent()}
      </div>
    </>
  );
}
